// ============================================================================
// RUSSIAN TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Увлекательные факты о Библии

export const bibleFacts = [
  {
    category: "структура",
    text: "Библия содержит 66 книг, написанных более чем 40 различными авторами на протяжении примерно 1500 лет",
    source: "Каноническая структура Библии"
  },
  {
    category: "размер",
    text: "Библия содержит 31 173 стиха, 1 189 глав и приблизительно 783 137 слов в своей оригинальной версии",
    source: "Библейский текстуальный анализ"
  },
  {
    category: "перевод",
    text: "Библия была переведена полностью или частично на более чем 3 000 языков, что делает её самой переводимой книгой в мире",
    source: "Объединённые библейские общества"
  },
  {
    category: "стих",
    text: "Самый короткий стих в Библии - 'Иисус прослезился' (Иоанна 11:35), а самый длинный - Есфирь 8:9",
    source: "Библейский текстуальный анализ"
  },
  {
    category: "популярность",
    text: "Библия - самая продаваемая книга всех времен, распространено более 5 миллиардов экземпляров",
    source: "Издательские записи"
  },
  {
    category: "история",
    text: "Свитки Мёртвого моря, обнаруженные в 1947 году, содержат библейские рукописи возрастом более 2 000 лет",
    source: "Библейская археология"
  },
  {
    category: "центр",
    text: "Центральная глава Библии - Псалом 118, а центральный стих - Псалом 118:8",
    source: "Числовая структура Библии"
  }
];

export default bibleFacts;
